import React, { useState } from 'react';
import Slider, { Settings } from 'react-slick';

import 'styled-components/macro';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { useMediaQuery } from 'react-responsive';

import { Image, SliderComponent, StyledDot } from './styledComponents';

interface ImageSlickProps {
  speakersImageUrls: any;
  mobileWidth: number;
}

function ImageSlick(props) {
  let { speakersImageUrls, mobileWidth } = props;
  const [activeSlide, setActiveSlide] = useState(0);

  const settings: Settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'ondemand',
    nextArrow: <></>,
    prevArrow: <></>,
    customPaging: (i) => <StyledDot isCurrentSlide={i === activeSlide} />,
    beforeChange: (current, next) => {
      setActiveSlide(next);
    }
  };
  const isMobile = useMediaQuery({
    query: `(max-width: ${mobileWidth}px)`
  });

  speakersImageUrls = JSON.parse(speakersImageUrls + '}');

  const slickImageUrls = isMobile
    ? speakersImageUrls.mobile
    : speakersImageUrls.desktop;

  if (speakersImageUrls) {
    return (
      <SliderComponent
        data-testid={'slider-component'}
        className="slick-slider-container"
      >
        <Slider {...settings}>
          {Object.keys(slickImageUrls).map((slide, index) => (
            <Image
              key={index}
              src={slickImageUrls[slide]}
              className="slick-slide-image"
            />
          ))}
        </Slider>
      </SliderComponent>
    );
  }
  return null;
}

export default ImageSlick;
